export default class AppPathname {
  static instance = new AppPathname();

  value = null;
}
